import _ from 'lodash';
import PropTypes, { InferProps } from 'prop-types';
//MUI
import { Box } from '@mui/material';
//Hooks
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations, selectedLanguage } from 'state/reducers/translation.reducers';
//Constants
import { IMenuItem, sideBarItems } from 'constants/ui.constants';
//styles
import { Drawer, CustomList, DrawerHeader, IconButton } from 'theme/layouts/sidebar';
import { MenuListItem } from 'components/MenuListItem';
import { SubMenu } from './SubMenu';
import { isLoading } from 'state/reducers/content.reducers';
import { ProfileComponent } from './ProfileComponent';
import { AuthorizationComponent } from 'components/AuthorizationComponent';

export const DashboardSidebar: any = ({
	toggleSidebar,
	open,
	profileSubmenuOpen,
	handleProfileIconClick,
	handleSubMenuClick,
	openSubMenu,
	subMenAnchorEl,
	handleMainMenuClickWithNoSub
}: InferProps<typeof DashboardSidebar.propTypes>) => {
	const t: any = useAppSelector(selectTranslations);
	const lang = useAppSelector(selectedLanguage);
	const isRTL = _.includes(lang, 'he');
	const dir = isRTL ? 'right' : 'left';
	const loading = useAppSelector(isLoading);

	return (
		<Drawer
			anchor={dir}
			variant="permanent"
			open={open}
			sx={{ '& .MuiPaper-root': { display: 'flex', justifyContent: 'space-between' } }}
		>
			<Box>
				<DrawerHeader open={open}>
					<IconButton
						onClick={() => toggleSidebar(!open)}
						sx={{ filter: 'brightness(0) invert(1)', display: { sm: 'block', xs: 'none' } }}
					>
						{open ? <img src={'/icons/logo-brand-name.png'} /> : <img src={'/icons/logo-brand-icon.svg'} />}
					</IconButton>
				</DrawerHeader>
				<CustomList>
					{sideBarItems?.map((sideBarItem: IMenuItem, index) => (
						<Box key={index}>
							<AuthorizationComponent permissions={sideBarItem.permissions}>
								<MenuListItem
									key={index}
									icon={sideBarItem.icon}
									name={t(`navbar.${sideBarItem.name}`)}
									open={open}
									handleClick={() => (sideBarItem?.children ? openSubMenu(sideBarItem) : handleMainMenuClickWithNoSub(sideBarItem))}
									hasSubmenu={sideBarItem.children ? true : false}
									submenuOpen={subMenAnchorEl === sideBarItem}
								/>
								{open && !loading && subMenAnchorEl === sideBarItem && (
									<SubMenu
										handleClick={handleSubMenuClick}
										open={!loading && subMenAnchorEl === sideBarItem}
									/>
								)}
							</AuthorizationComponent>
						</Box>
					))}
				</CustomList>
			</Box>
			<ProfileComponent
				open={open}
				profileSubmenuOpen={profileSubmenuOpen}
				handleProfileIconClick={() => handleProfileIconClick(!profileSubmenuOpen)}
			/>
		</Drawer>
	);
};

DashboardSidebar.propTypes = {
	open: PropTypes.bool.isRequired,
	toggleSidebar: PropTypes.func.isRequired,
	mobile: PropTypes.bool,
	setAnchorEl: PropTypes.func.isRequired,
	anchorEl: PropTypes.any,
};
